import * as React from 'react';
import { Builder, BuilderElement } from '@builder.io/react';
import image from '@/assets/images/cms/tabs.svg?inline';

export interface TabsComponentProps {
	readonly tabs?: readonly TabProps[];
}

export interface TabProps {
	readonly label: string;
	readonly content: BuilderElement[];
}

const register = <TProps extends TabsComponentProps>(Component: React.FC<TProps>): void => {
	const defaultElement = {
		'@type': '@builder.io/sdk:Element',
		component: {
			name: 'Text',
			options: {
				text: 'New tab content ',
			},
		},
	};

	Builder.registerComponent(Component, {
		name: 'Tabs',
		image,
		inputs: [
			{
				name: 'tabs',
				type: 'list',
				broadcast: true,
				subFields: [
					{
						name: 'label',
						type: 'string',
						defaultValue: 'Tab title',
					},
					{
						name: 'content',
						type: 'uiBlocks',
						hideFromUI: true,
						defaultValue: [defaultElement],
					},
				],
				defaultValue: [
					{
						label: 'Some tab',
						content: [
							{
								...defaultElement,
								component: {
									name: 'Text',
									options: {
										text: 'Tab 1 content',
									},
								},
							},
						],
					},
					{
						label: 'Some other tab',
						content: [
							{
								...defaultElement,
								component: {
									name: 'Text',
									options: {
										text: 'Tab 2 content',
									},
								},
							},
						],
					},
				],
			},
		],
	});
};

export default register;
